import { APITypes } from '../primary-record-types';
import { Platform } from 'react-native';

export type UseClientTypeReturnValue = {};

export type ClientType = APITypes.sharedTypes.ClientType;
export function getClientType() {
    if (Platform.OS === 'web') {
        if (window.location.hostname.includes('localhost')) {
            return 'local-web';
        } else if (window.location.hostname.includes('dev')) {
            return 'dev-web';
        } else {
            return 'prod-web';
        }
    } else {
        return __DEV__ ? 'mobile-dev' : 'mobile';
    }
}
